module.exports = __webpack_public_path__ + "static/media/SolidDownArrow.fc3428a9.svg";